import React, { useEffect, useState } from 'react'
import * as Helpers from '../helpers.mjs'
import { fetchJson } from "../fetch.js"

const BookPackCollage = ({ source }) => {

    const {product_id, title } = source;

    const isBooksForTopicsPack = (source.origin.replace(/\W+/g, '').toLowerCase() == "booksfortopics");

    const [bookPackLinks, setBookPackLinks] = useState([]);
    
    useEffect(() => {
        fetchJson("/product/getBookPackImages/"+product_id).then(r => {
            setBookPackLinks(r);
        });
    },[]);

    var bookPackImages = [];
    if (bookPackLinks.length > 1) { bookPackLinks.map(b => bookPackImages.push(Helpers.getProductImageLink(b.prEan13))); }
    const shuffledImages = [...bookPackImages].sort(() => 0.5 - Math.random());
    bookPackImages= shuffledImages.slice(0, 9);
    
    const bookPackBadges = [
        "/assets/img/bookPackBadges/blue.png",
        "/assets/img/bookPackBadges/green.png",
        "/assets/img/bookPackBadges/jade.png",
        "/assets/img/bookPackBadges/purple.png",
        "/assets/img/bookPackBadges/red.png",
        "/assets/img/bookPackBadges/steel.png",
        "/assets/img/bookPackBadges/yellow.png"
    ];
    const randomIndex = Math.floor(Math.random() * bookPackBadges.length);
    const randomBookPackBadge = bookPackBadges[randomIndex];

    return (
        <div className="bookPackCollage lazy " key={product_id} title={title} alt={title} onError={(e) => {handleImageError(e.target)}} style={{ height: "33.3%"}}>
            {bookPackImages.map(image => (
                <img className="bookPackCollageImage" src={image} style={{ width: "33.3%"}} />
            ))}
            <div className="bookBadge bookPackCollage overlay">
                <img className="bookPackBadgeImage" src={isBooksForTopicsPack ? "/assets/img/bookPackBadges/bftBand.png" : randomBookPackBadge} alt="Book pack" />
            </div>
        </div>
    );
    // var productImgSrc = "";
    // if (bookPackImages.length <= 1 && isBooksForTopicsPack) {
    //     productImgSrc = "/assets/img/booksForTopics.jpg";
    // } else if (bookPackImages.length <= 1) {
    //     const imageFolder = product_id.substring(product_id.length - 3);
    //     productImgSrc = `${Helpers.imageURLPrefix()}/covers/large/${imageFolder}/${product_id}.jpg`;
    // }
    // return <>
    //     {bookPackImages.length > 1 && <div className="bookPackCollage lazy " key={product_id} title={title} alt={title} onError={(e) => {handleImageError(e.target)}} style={{ height: "33.3%"}}>
    //         {bookPackImages.map(image => (
    //             <img className="bookPackCollageImage" src={image} style={{ width: "33.3%"}} />
    //         ))}
    //         <div className="bookBadge bookPackCollage overlay">
    //             <img className="bookPackBadgeImage" src={isBooksForTopicsPack ? "/assets/img/bookPackBadges/bftBand.png" : randomBookPackBadge} alt="Book pack" />
    //         </div>
    //     </div>}
    //     {bookPackImages.length <= 1 && productImgSrc !== "" && <>
    //         <img className="productImg lazy bookImg testing" src={productImgSrc} key={product_id} title={title} alt={title} onError={(e) => { handleImageError(e.target) }} />
    //     </>}
    // </>;
}

export default BookPackCollage;